import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_mt-3" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_auto_complete_field = _resolveComponent("auto-complete-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "show-action-close": true,
    "is-visible": _ctx.isUserLocationModalVisible,
    title: _ctx.Resources.Layout.UserLocationModalTitle,
    "is-processing": _ctx.isProcessing,
    onActionClose: $options.onClose
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link _ttl _tc--lighter",
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.onClose && $options.onClose(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, _toDisplayString(_ctx.Resources.Layout.ModalCancelButton), 1 /* TEXT */),
      _createVNode(_component_base_button, {
        disabled: _ctx.isProcessing,
        size: "default",
        width: "compact",
        "text-transform": "none",
        bold: true,
        theme: "accent",
        enabled: !_ctx.isProcessing,
        onClick: _withModifiers($options.onSave, ["prevent"]),
        "data-qa": "modal-button:Save"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Layout.ModalSaveButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "enabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Resources.Layout.UserLocationModalInformation) + " ", 1 /* TEXT */),
      _createElementVNode("fieldset", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.Resources.Layout.UserLocationModalFieldsetHeading), 1 /* TEXT */),
        _createVNode(_component_auto_complete_field, {
          modelValue: _ctx.model.locationID,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = $event => ((_ctx.model.locationID) = $event)),
            $options.setLocationID
          ],
          name: "model.locationID",
          items: _ctx.locations,
          "min-chars": 0,
          "item-name-finder": item => item.name,
          "item-value-finder": item => item.locationID,
          placeholder: _ctx.Resources.Layout.UserLocationModalLocationFieldPlaceholder,
          "data-qa": "delivered-to:Location"
        }, null, 8 /* PROPS */, ["modelValue", "items", "item-name-finder", "item-value-finder", "placeholder", "onUpdate:modelValue"]),
        ($options.hasSublocations)
          ? (_openBlock(), _createBlock(_component_auto_complete_field, {
              key: 0,
              modelValue: _ctx.model.subLocationID,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = $event => ((_ctx.model.subLocationID) = $event)),
                $options.setSublocationID
              ],
              name: "model.subLocationID",
              items: $options.sublocations,
              "min-chars": 0,
              "item-name-finder": item => item.name,
              "item-value-finder": item => item.subLocationID,
              placeholder: _ctx.Resources.Layout.UserLocationModalSubLocationFieldPlaceholder,
              "data-qa": "delivered-to:Sublocation"
            }, null, 8 /* PROPS */, ["modelValue", "items", "item-name-finder", "item-value-finder", "placeholder", "onUpdate:modelValue"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "title", "is-processing", "onActionClose"]))
}